import { render, staticRenderFns } from "./xy.vue?vue&type=template&id=f47c845c&scoped=true&"
import script from "./xy.vue?vue&type=script&lang=js&"
export * from "./xy.vue?vue&type=script&lang=js&"
import style0 from "./xy.vue?vue&type=style&index=0&id=f47c845c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c845c",
  null
  
)

export default component.exports